import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './divider.js';

const listItemDividerCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:.5rem 0}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";
const WuiListItemDividerStyle0 = listItemDividerCss;

const WuiListItemDivider = /*@__PURE__*/ proxyCustomElement(class WuiListItemDivider extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: '70b7f4e593990e6710031ea2cdb021f909419f45' }, h("wui-divider", { key: 'e6e8a44709e767def9b41dec0245a3ee42735d39' })));
    }
    static get style() { return WuiListItemDividerStyle0; }
}, [1, "wui-list-item-divider"]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-list-item-divider", "wui-divider"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiListItemDivider);
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiListItemDivider as W, defineCustomElement as d };

//# sourceMappingURL=list-item-divider.js.map